import type { TableDataType } from "../../types";

type RankDisplayProps = {
  entry: TableDataType;
};

const RankDisplay = ({ entry }: RankDisplayProps) => {
  const currentRank = entry.rank;
  const previousRank = entry.previousRank;

  let diff: number | undefined = undefined;

  if (typeof previousRank === "number" && typeof currentRank === "number") {
    diff = previousRank - currentRank;
  }

  return (
    <div className={"flex flex-col gap-[6px]"}>
      <span className={"font-bold text-[18px] leading-[130%] text-black-rock"}>
        {currentRank}
      </span>
      <span className={"text-[14px] leading-[130%]"}>
        {diff === undefined && <span>New</span>}
        {diff === 0 && <span className={"text-mono-20"}>( - )</span>}
        {diff !== undefined && diff > 0 && (
          <span className={"text-[#00C087]"}>+{diff}</span>
        )}
        {diff !== undefined && diff < 0 && (
          <span className={"text-[#E52900]"}>{diff}</span>
        )}
      </span>
    </div>
  );
};

export default RankDisplay;
